import { useState, useEffect, useRef } from 'react';

const useAutoLogout = (logoutDuration, debounceDelay = 1000) => {
    const [isActive, setIsActive] = useState(true);
    const logoutTimeoutRef = useRef(null);

    const debouncedResetLogoutTimer = debounce(() => {
        if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
        logoutTimeoutRef.current = setTimeout(() => {
            setIsActive(false);
        }, logoutDuration);
    }, debounceDelay);

    useEffect(() => {
        document.addEventListener('mousemove', debouncedResetLogoutTimer);
        document.addEventListener('keydown', debouncedResetLogoutTimer);

        debouncedResetLogoutTimer();

        return () => {
            if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
            document.removeEventListener('mousemove', debouncedResetLogoutTimer);
            document.removeEventListener('keydown', debouncedResetLogoutTimer);
        };
    }, []);

    return isActive;
};

export default useAutoLogout;


function debounce(fn, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
}
